import React from 'react';
import { Card } from '../../../components/base/Card';

export const TechSection: React.FC = () => {
  return (
    <>
      {/* Tecnología y Seguridad */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-primary-800 mb-6">
              Tecnología y Seguridad
            </h2>
            <div className="w-24 h-1 bg-primary-600 mx-auto mb-8"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Protección y transparencia en cada transacción
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <Card className="p-8 hover:shadow-2xl transition-all duration-300 border-l-4 border-primary-600">
              <div className="w-14 h-14 bg-primary-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-lock-line text-2xl text-primary-600"></i>
              </div>
              <p className="text-gray-700 leading-relaxed">
                Cada enlace está cifrado y vinculado a una cuenta única.
              </p>
            </Card>

            <Card className="p-8 hover:shadow-2xl transition-all duration-300 border-l-4 border-primary-600">
              <div className="w-14 h-14 bg-primary-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-2xl text-primary-600"></i>
              </div>
              <p className="text-gray-700 leading-relaxed">
                Las operaciones se validan automáticamente antes de liberar comisiones.
              </p>
            </Card>

            <Card className="p-8 hover:shadow-2xl transition-all duration-300 border-l-4 border-primary-600">
              <div className="w-14 h-14 bg-primary-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-secure-payment-line text-2xl text-primary-600"></i>
              </div>
              <p className="text-gray-700 leading-relaxed">
                Los pagos se hacen por plataformas seguras.
              </p>
            </Card>

            <Card className="p-8 hover:shadow-2xl transition-all duration-300 border-l-4 border-primary-600">
              <div className="w-14 h-14 bg-primary-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-dashboard-line text-2xl text-primary-600"></i>
              </div>
              <p className="text-gray-700 leading-relaxed">
                El sistema incluye panel de control para referidores y proveedores.
              </p>
            </Card>

            <Card className="p-8 hover:shadow-2xl transition-all duration-300 border-l-4 border-primary-600">
              <div className="w-14 h-14 bg-primary-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-eye-line text-2xl text-primary-600"></i>
              </div>
              <p className="text-gray-700 leading-relaxed">
                Se puede rastrear cada acción, descarga, venta y pago en tiempo real.
              </p>
            </Card>
          </div>
        </div>
      </section>

      {/* Misión y Visión */}
      <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-primary-800 mb-6">
              Misión y Visión
            </h2>
            <div className="w-24 h-1 bg-primary-600 mx-auto"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            <Card className="p-10 hover:shadow-2xl transition-all duration-300 border-t-4 border-primary-600">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-compass-line text-3xl text-primary-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-primary-800 mb-4">Misión</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Empoderar a las personas para que ganen dinero conectando a otros con soluciones que realmente necesitan.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Promover una economía digital colaborativa, justa y accesible.
              </p>
            </Card>

            <Card className="p-10 hover:shadow-2xl transition-all duration-300 border-t-4 border-primary-600">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-eye-line text-3xl text-primary-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-primary-800 mb-4">Visión</h3>
              <p className="text-gray-700 leading-relaxed">
                Convertirnos en la plataforma de referidos líder en Latinoamérica, integrando miles de negocios locales, freelancers y empresas en un solo ecosistema digital.
              </p>
            </Card>
          </div>

          {/* Valores */}
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-primary-800 mb-8">Valores</h3>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
            {[
              { icon: 'ri-eye-2-line', text: 'Transparencia' },
              { icon: 'ri-hand-heart-line', text: 'Confianza' },
              { icon: 'ri-team-line', text: 'Colaboración' },
              { icon: 'ri-lightbulb-line', text: 'Innovación' },
              { icon: 'ri-checkbox-circle-line', text: 'Simplicidad' },
            ].map((value, index) => (
              <div key={index} className="text-center">
                <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4 hover:bg-primary-600 hover:scale-110 transition-all duration-300 group">
                  <i className={`${value.icon} text-3xl text-primary-600 group-hover:text-white`}></i>
                </div>
                <p className="font-semibold text-primary-800">{value.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonios */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-primary-800 mb-6">
              Testimonios
            </h2>
            <div className="w-24 h-1 bg-primary-600 mx-auto"></div>
          </div>

          <div className="max-w-4xl mx-auto">
            <Card className="p-10 hover:shadow-2xl transition-all duration-300 border-l-4 border-primary-600">
              <div className="flex items-start space-x-4">
                <i className="ri-double-quotes-l text-5xl text-primary-600 flex-shrink-0"></i>
                <div>
                  <p className="text-xl text-gray-700 leading-relaxed mb-6 italic">
                    Solo compartí mi enlace con mis contactos y al día siguiente ya tenía mis primeras comisiones. Es real.
                  </p>
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-user-line text-2xl text-primary-600"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-primary-800">Carlos M.</p>
                      <p className="text-gray-600">Referidor BiviLinks</p>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </section>
    </>
  );
};
